<script>
import {Editor, Toolbar} from '@wangeditor/editor-for-vue'
import {DomEditor} from '@wangeditor/editor'
import { marked } from 'marked'

export default {
  name: "wangeditor5",
  components: {Editor, Toolbar},
  props: {
    content: {
      default() {
        return null;
      },
    },
    toolbarConfig:{
      default() {
        return {
          // toolbarKeys: [ /* 显示哪些菜单，如何排序、分组 */ ],
          // excludeKeys: [ /* 隐藏哪些菜单 */ ],
        }
      },
    },
    height:{
      default() {
        return 400;
      },
    },
    styleObject:{
      default() {
        return null;
      },
    },
    token: {
      type: String,
      default: ''
    },
    showToolbar:{
      default() {
        return true;
      }
    },
    // 是否支持 Markdown 粘贴转换
    markdownSupport: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      editor: null,
      html: '',
      editorConfig: {
        placeholder: '请输入内容，支持粘贴 Markdown 格式...',
        MENU_CONF: {}  // 先初始化一个空的 MENU_CONF
      }
    }
  },
  created() {
      // 确保有 token 后再设置上传配置
      this.editorConfig.MENU_CONF.uploadImage = {
        server: window.location.protocol === "http:" ? "http://up-z1.qiniu.com" : "https://upload-z1.qbox.me",
        fieldName: 'file',
        maxFileSize: 10 * 1024 * 1024, // 10M
        maxNumberOfFiles: 10,
        allowedFileTypes: ['image/*'],
        // 上传之前触发
        onBeforeUpload: async (file) => {
          console.log('上传之前触发', file)
          return file
        },
        // 自定义上传
        customUpload: async (file, insertFn) => {
          try {
            let formData = new FormData();
            let qiniuToken = await this.getQiniuTokenFn();
            formData.append("token", qiniuToken);
            formData.append("file", file);
            let qiniuUrl = window.location.protocol === "http:" ? "http://up-z1.qiniu.com" : "https://upload-z1.qbox.me"
            let data = await this.$axios.post(qiniuUrl, formData);
            console.log('上传结果', data)
            if(data) {
              const imageUrl = `${window.configure.qiniuUrl}/${data.key}`;
              // 插入图片时使用完整的HTML字符串，包含样式
              const imageHtml = `<img src="${imageUrl}" style="max-width:100% !important;width:100% !important;height:auto !important;display:block !important;" alt="上传图片" />`;
              insertFn(imageUrl, imageHtml)
            }
          } catch (error) {
            console.error('图片上传失败:', error)
          }
        },
        // 上传成功触发
        onSuccess: (file, res) => {
          console.log('图片上传成功', res)
        },
        // 上传失败触发
        onFailed: (file, res) => {
          console.log('图片上传失败', res)
        },
        // 上传错误触发
        onError: (file, err, res) => {
          console.log('图片上传错误', err, res)
        }
      }

  },
  watch: {
    content: {
      handler() {
        this.$nextTick(() => {
          this.html = this.content;


        })
      },
      immediate: true
    }
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor) // 【注意】一定要用 Object.seal() 否则会报错
      
      // 添加粘贴事件监听，支持 Markdown 转换
      if (this.markdownSupport) {
        this.setupMarkdownPaste(editor)
      }
    },
    // 设置 Markdown 粘贴支持
    setupMarkdownPaste(editor) {
      const editorEl = editor.getEditableContainer()
      if (!editorEl) return
      
      editorEl.addEventListener('paste', (e) => {
        const clipboardData = e.clipboardData || window.clipboardData
        const pastedText = clipboardData.getData('text/plain')
        
        // 检测是否是 Markdown 格式
        if (this.isMarkdown(pastedText)) {
          e.preventDefault()
          
          // 转换 Markdown 为 HTML
          const html = marked.parse(pastedText, {
            breaks: true,
            gfm: true
          })
          
          // 插入转换后的 HTML
          editor.dangerouslyInsertHtml(html)
        }
      })
    },
    // 检测文本是否是 Markdown 格式
    isMarkdown(text) {
      if (!text) return false
      
      // Markdown 特征检测
      const mdPatterns = [
        /^#{1,6}\s+/m,           // 标题 # ## ###
        /^\*{1,3}[^*]+\*{1,3}/m, // 加粗/斜体 *text* **text**
        /^[-*+]\s+/m,            // 无序列表 - * +
        /^\d+\.\s+/m,            // 有序列表 1. 2.
        /^\[.+\]\(.+\)/m,        // 链接 [text](url)
        /^>\s+/m,                // 引用 >
        /^```/m,                 // 代码块 ```
        /`[^`]+`/,               // 行内代码 `code`
        /^\|.+\|/m,              // 表格 |col|col|
        /^---+$/m,               // 分割线 ---
        /^___+$/m,               // 分割线 ___
        /^\*\*\*+$/m,            // 分割线 ***
      ]
      
      // 如果匹配到2个以上 Markdown 特征，认为是 Markdown
      let matchCount = 0
      for (const pattern of mdPatterns) {
        if (pattern.test(text)) {
          matchCount++
          if (matchCount >= 2) return true
        }
      }
      
      return false
    },
    onChange(editor) {
      if(editor.getHtml() === '<p><br></p>') {
        this.$emit("update:content", '');
      } else {
        this.$emit("update:content", editor.getHtml());
      }
    },
    // 手动将 Markdown 转换为 HTML 并设置
    setMarkdownContent(mdContent) {
      if (!mdContent) return
      
      const html = marked.parse(mdContent, {
        breaks: true,
        gfm: true
      })
      this.html = html
      this.$emit("update:content", html)
    },
    insertTextHandler() {
      const editor = this.editor
      if (editor == null) return
      editor.insertText(' hello ')
    },
    printEditorHtml() {
      const editor = this.editor
      if (editor == null) return
      console.log(editor.getHtml())
    },
    disableHandler() {
      const editor = this.editor
      if (editor == null) return
      editor.disable()
    }
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁 editor ，重要！！！
  },
}
</script>

<template>
  <div class="wangeditor-container">
    <!-- 工具栏 -->
    <Toolbar
        :editor="editor"
        v-if="showToolbar"
        :defaultConfig="toolbarConfig"
    />
    <!-- 编辑器 -->
    <Editor
        style="overflow-y: hidden;"
        :style="styleObject? styleObject : {height: height + 'px'}"
        :defaultConfig="editorConfig"
        v-model="html"
        @onChange="onChange"
        @onCreated="onCreated"
    />
  </div>
</template>

<style scoped lang="less">

</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="less">
// 富文本编辑器增强样式
.w-e-text-container {
  border-radius: 0 0 8px 8px;
  
  [data-slate-editor] {
    padding: 16px;
    min-height: 200px;
  }
}

.w-e-toolbar {
  border-radius: 8px 8px 0 0;
  background: #f8fafc !important;
  border-bottom: 1px solid #e4e7ed !important;
}

// 富文本容器样式
.wangeditor-container {
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  overflow: hidden;
  transition: border-color 0.3s ease;
  
  &:hover {
    border-color: #c0c4cc;
  }
  
  &:focus-within {
    border-color: #2B77FF;
  }
}
</style>
